// Vendors
import React, { Fragment } from 'react';
import { isMobileDevice } from '@openbank/cf-ui-framework';
// Components
import { BannerDownloadAppComponent } from '../banner-download-app/banner-download-app.component';
import { AssetComponent, ModalComponent } from '@openbank/cb-ui-commons';
import ErrorWrapperComponent from 'components/error-wrapper/error-wrapper.component';
// Configurations
import { getDownloadAppModalConfiguration } from './configurations/download-app-modal.configurations';
// Constants
import {
  CHANGE_PHONE_MODAL_DESKTOP_ASSET_PROPS,
  CHANGE_PHONE_MODAL_MOBILE_ASSET_PROPS,
  CHANGE_PHONE_MODAL_WRAPPER,
} from './constants/download-app-modal.constants';
// Styled
import {
  AssetWrapper,
  DownloadAppModalContainer,
  DownloadAppModalWrapper,
} from './download-app-modal.styled';
// Types
import { DownloadAppModalPropsType } from './types/download-app-modal.component.types';

export const DownloadAppModal = ({
  error = false,
  fetching = false,
  handleCloseModal,
  isModalOpen,
  translations,
}: DownloadAppModalPropsType): React.ReactElement | null => {
  const configuration = getDownloadAppModalConfiguration({ error, fetching, handleCloseModal });

  if (!isModalOpen) {
    return <Fragment />;
  }

  return (
    <DownloadAppModalContainer>
      <ModalComponent {...configuration}>
        <DownloadAppModalWrapper {...CHANGE_PHONE_MODAL_WRAPPER}>
          <ErrorWrapperComponent {...{ error, fetching }}>
            <AssetWrapper>
              <AssetComponent
                {...(isMobileDevice()
                  ? CHANGE_PHONE_MODAL_MOBILE_ASSET_PROPS
                  : CHANGE_PHONE_MODAL_DESKTOP_ASSET_PROPS)}
              />
            </AssetWrapper>
            <BannerDownloadAppComponent translations={translations} />
          </ErrorWrapperComponent>
        </DownloadAppModalWrapper>
      </ModalComponent>
    </DownloadAppModalContainer>
  );
};
